export default "__VITE_ASSET__BR3I28K7__"